import React, { useState } from "react";
import styled from "styled-components";

import TextField from "@material-ui/core/TextField";

import ProtocolData from "./ProtocolData";
import Button from "../components/Button";

const ProtocolSearch = () => {
  const [protocolId, setProtocolId] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSearch = () => {
    setIsLoading(true);
  };

  return (
    <>
      {!isLoading ? (
        <Container>
          <Separator />
          <>
            <TextField
              label="Digite o seu protocolo*"
              value={protocolId}
              onChange={(e) => setProtocolId(e.target.value)}
            />
            <Separator />
            <ButtonContainer>
              <Button
                variant="contained"
                color="primary"
                disabled={isLoading || protocolId.length < 20}
                onClick={() => handleSearch()}
              >
                {!isLoading ? "Pesquisar" : "Carregando..."}
              </Button>
            </ButtonContainer>
          </>
        </Container>
      ) : (
        <ProtocolData protocolId={protocolId.trim()} />
      )}
    </>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Separator = styled.div`
  margin: 10px 0;
`;

export default ProtocolSearch;
